import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Company, NewCompany } from '@app/_models/company';

@Injectable({ providedIn: 'root' })
export class CompanyService {
    constructor(private http: HttpClient) { }

    get_all_companies(){
        return this.http.get<Company[]>(`${environment.apiUrl}/auth/companies`);
    }

    add_company(company: NewCompany) {
        return this.http.post(`${environment.apiUrl}/auth/add-company`, company);
    }

    change_company_status(company_id:string, status:string) {
        var data = {'id': company_id, 'status': status}
        return this.http.post(`${environment.apiUrl}/auth/disable-company`, data);
    }

    edit_company(code:string, name:string, company_id:number) {
        var data = {'company_id': company_id, 'code': code, 'name': name}
        return this.http.post(`${environment.apiUrl}/auth/edit-company`, data);
    }
}
